(() => {
  // src/scripts/entries/boho-smart-cart.js
  if (window.themeVariables.settings.useRebuySmartCart) {
    let updateCartCount = function() {
      var _a, _b;
      const cart = (_b = (_a = window.Rebuy) == null ? void 0 : _a.Cart) == null ? void 0 : _b.getCart();
      if (cart && Number.isFinite(cart.item_count)) {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", { bubbles: true, detail: { cart } })
        );
      }
    };
    updateCartCount2 = updateCartCount;
    let opening = false;
    async function openSmartCart() {
      var _a, _b;
      if (opening) {
        return;
      }
      const rebuy = window.Rebuy;
      if (((_a = rebuy == null ? void 0 : rebuy.SmartCart) == null ? void 0 : _a.status) !== "ready" || typeof rebuy.SmartCart.show !== "function" || typeof ((_b = rebuy.Cart) == null ? void 0 : _b.fetchShopifyCart) !== "function") {
        window.location.assign(window.themeVariables.routes.cartUrl);
        return;
      }
      opening = true;
      let timeout;
      try {
        const unavailable = new Promise((_, reject) => {
          timeout = window.setTimeout(
            () => reject(new Error("Rebuy unavailable")),
            1e3
          );
        });
        await Promise.race([
          // Theme AJAX requests bypass Rebuy's addItem method; reload its cart first.
          new Promise((resolve, reject) => {
            const request = rebuy.Cart.fetchShopifyCart(resolve);
            request == null ? void 0 : request.catch(reject);
          }),
          unavailable
        ]);
        updateCartCount();
        rebuy.SmartCart.show();
      } catch (error) {
        console.warn("Unable to open Rebuy Smart Cart:", error);
        window.location.assign(window.themeVariables.routes.cartUrl);
      } finally {
        window.clearTimeout(timeout);
        opening = false;
      }
    }
    document.addEventListener("click", (event) => {
      const toggle = event.target.closest("[data-smart-cart-toggle]");
      if (!toggle || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      event.preventDefault();
      void openSmartCart();
    });
    document.addEventListener("cart:refresh", (event) => {
      var _a, _b;
      if (((_a = event.detail) == null ? void 0 : _a.openSmartCart) || ((_b = event.detail) == null ? void 0 : _b.openMiniCart)) {
        void openSmartCart();
      }
    });
    document.addEventListener("rebuy:cart.change", updateCartCount);
  }
  var updateCartCount2;
})();
